import { api } from '../api/axios';

export const authService = {
  login: async (email, password) => {
    const response = await api.post('/auth/login', { email, password });
    return response.data;
  },
  register: async (email, password, department) => {
    const response = await api.post('/users/register', { email, password, department });
    return response.data;
  },
};

export const moduleService = {
  listModules: async () => {
    const response = await api.get('/modules');
    return response.data;
  },
};

export const accessRequestService = {
  createRequest: async (moduleIds, justification, urgent) => {
    const response = await api.post('/access-requests', {
      moduleIds,
      justification,
      urgent,
    });
    return response.data;
  },
  listRequests: async (filters = {}) => {
    const response = await api.get('/access-requests', { params: filters });
    return response.data;
  },
  getRequestById: async (id) => {
    const response = await api.get(`/access-requests/${id}`);
    return response.data;
  },
  cancelRequest: async (id, reason) => {
    const response = await api.post(`/access-requests/${id}/cancel`, { reason });
    return response.data;
  },
  renewRequest: async (id) => {
    const response = await api.post(`/access-requests/${id}/renew`);
    return response.data;
  },
};
